// extracted by mini-css-extract-plugin
export var blueBackgroundImage = "H_bQ";
export var metadata = "H_bR";
export var postImage = "H_bP";
export var tagsContainer = "H_bS";
export var title = "H_h";